import { useState, useEffect } from "react";
import { useBach } from "@/context/BachContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { SaveBadge } from "@/components/shared";
import BachManager from "@/components/BachManager";
import { SECTIONS } from "@/lib/bachConfig";
import { Palette } from "lucide-react";

const THEME_IMAGES = {
  entity: "theme", title: "Inspiration Images", subtitle: "Save looks and moodboard ideas.", icon: Palette,
  fields: [{ key: "caption", label: "Caption", full: true }, { key: "image", label: "Image", full: true, type: "image" }],
  columns: [{ key: "caption", label: "Caption" }], image: "image",
};

export default function BachTheme() {
  const { profile, save, saveStatus } = useBach();
  const [local, setLocal] = useState({});
  useEffect(() => { if (profile) setLocal(profile); }, [profile]);
  const set = (k, v) => setLocal((p) => ({ ...p, [k]: v }));

  return (
    <div className="space-y-8">
      <div className="flex items-end justify-between">
        <div><h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#2A181C]">Theme & Inspiration</h1><p className="text-[#7A686C] mt-2">Set the vibe for the whole celebration.</p></div>
        <SaveBadge status={saveStatus} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 rounded-2xl bg-white border border-[#EFE3DE] p-6">
        <div><Label className="text-xs text-[#7A686C]">Theme name</Label><Input value={local.theme_name || ""} onChange={(e) => set("theme_name", e.target.value)} onBlur={(e) => save({ theme_name: e.target.value })} className="rounded-xl mt-1 border-[#EFE3DE] focus-visible:ring-[#D8BD9E]" data-testid="bach-theme-name" /></div>
        <div><Label className="text-xs text-[#7A686C]">Overall vibe</Label><Input value={local.vibe || ""} onChange={(e) => set("vibe", e.target.value)} onBlur={(e) => save({ vibe: e.target.value })} placeholder="e.g. Old-money Riviera glamour" className="rounded-xl mt-1 border-[#EFE3DE] focus-visible:ring-[#D8BD9E]" data-testid="bach-theme-vibe" /></div>
        <div className="sm:col-span-2"><Label className="text-xs text-[#7A686C]">Inspiration notes</Label><Textarea value={local.inspiration_notes || ""} onChange={(e) => set("inspiration_notes", e.target.value)} onBlur={(e) => save({ inspiration_notes: e.target.value })} rows={4} className="rounded-xl mt-1 border-[#EFE3DE] focus-visible:ring-[#D8BD9E]" data-testid="bach-theme-notes" /></div>
      </div>
      <BachManager config={THEME_IMAGES} />
    </div>
  );
}
